export default __webpack_public_path__ + "static/media/dish.3f91d382.png";